import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, Typography } from '@mui/material'
import React from 'react'
import { ShortenedNameV2 } from '@labrav/common'
import { isEmpty } from 'lodash'
import { useStyles } from './CellWithLinkText.styles'

export type CellWithLinkTextProps = {
  linkText: string | JSX.Element
  linkUrl: string
  descText?: string
  length?: number
  linkUrlToText?: boolean
}

export const CellWithLinkText = ({
  linkText,
  linkUrl,
  descText,
  length,
  linkUrlToText = true,
}: CellWithLinkTextProps) => {
  const { classes } = useStyles({ linkUrlToText })
  const handleClickLink: React.MouseEventHandler<HTMLAnchorElement> = event => {
    event.stopPropagation()
    window.open(linkUrl, '_blank')
  }
  return (
    <div className={classes.textCellWrapper}>
      {linkText ? (
        <div className={classes.textWithLink}>
          <ShortenedNameV2 name={linkText} length={length} />
          {isEmpty(linkUrl) ? null : (
            <Link
              target="_blank"
              data-testid="cell-link"
              className={classes.linkWrapper}
              onClick={handleClickLink}
            >
              <FontAwesomeIcon
                icon={faArrowUpRightFromSquare}
                className={classes.linkIcon}
              />
            </Link>
          )}
        </div>
      ) : (
        <div>-</div>
      )}
      {descText && (
        <Typography className={classes.subRowText}>{descText}</Typography>
      )}
    </div>
  )
}
